import type { TGetSimulacoesPorIdsResponse } from '@/shared/interfaces'
import { HttpService } from '@/shared/lib/http'

export class GetSimulacoesPorIds extends HttpService {
  execute = async (ids: string[]) => {
    return this.http.get<TGetSimulacoesPorIdsResponse>(`/api/v2/Simulacao/lista`, {
      params: { ids },
      paramsSerializer: { indexes: null },
    })
  }
}
